export const ACCORDION = 'accordion';
